import React from "react";
import { Pane, Select, TextInput } from "evergreen-ui";
export const Relation = ({ field, types }) => {
  return (
    <Pane>
      <Select
        value={field.multi}
        onChange={e => (field.multi = e.target.value)}
      >
        <option value={false}>Wybierz</option>
        <option value="single">Single</option>
        <option value="multi">Multi</option>
      </Select>
      <TextInput
        placeholder="FIeld name"
        value={field.pivotName}
        onChange={e => (field.pivotName = e.target.value)}
      />
      {field.multi && (
        <Select
          value={field.connected}
          onChange={e => (field.connected = e.target.value)}
        >
          <option value={false}>Wybierz</option>
          {types.map(type => (
            <option key={type._id} value={type._id}>
              {JSON.parse(type.data).name}
            </option>
          ))}
          <option value={"USER"}>User</option>
        </Select>
      )}
    </Pane>
  );
};
